import { AfterContentInit, Component, ContentChild, Input } from '@angular/core';
import { CommonModule, NgClass } from '@angular/common';
import { EzInputDirective } from './ez-input.directive';
import { EzRightDirective } from './ez-right.directive';
import { combineLatest, combineLatestWith, Observable, startWith } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Validators } from '@angular/forms';

@Component({
  selector: 'app-ez-input',
  standalone: true,
  templateUrl: './ez-input.component.html',
  styleUrls: ['./ez-input.component.scss'],
  imports: [
    CommonModule,
    NgClass,
  ]
})
export class EzInputComponent implements AfterContentInit {
  @ContentChild(EzInputDirective) ezInput!: EzInputDirective;
  @ContentChild(EzRightDirective) content!: EzRightDirective;

  @Input() isMasked: boolean = false;

  isFocus$: Observable<boolean>;
  isActive$: Observable<boolean>;

  isInvalidStatus$: Observable<boolean> | undefined = undefined;

  isRequired: boolean = false;
  isReadOnly: boolean = false;

  ngAfterContentInit(): void {
    if (!this.ezInput || !this.ezInput.elementRef || !this.ezInput.control) { return }

    if (this.ezInput.control.control) {
      this.isRequired = this.ezInput.control.control.hasValidator(Validators.required);
    }

    this.isReadOnly = this.ezInput.elementRef.nativeElement.readonly;

    this.isInvalidStatus$ = combineLatest([
      this.ezInput.control.statusChanges?.pipe(startWith(this.ezInput.control.status)),
      this.ezInput.focused.pipe(startWith(false))
    ]).pipe(
      filter(() => !!this.ezInput.control.value || !!this.ezInput.control.touched),
      map(() => this.ezInput.control.status === 'INVALID'),
    );

    this.isFocus$ = this.ezInput.focused.pipe(
      startWith(false)
    );

    this.isActive$ = this.isFocus$.pipe(
      combineLatestWith(
        this.ezInput.control.valueChanges!.pipe(startWith(this.ezInput.control.control?.getRawValue()))
      ),
      map(([isFocus, value]) => isFocus || !!value || !!this.ezInput.elementRef.nativeElement.value || !!this.isMasked)
    )
  }
}
